export default {
  IdNumber: 'رقم الهوية',
  password: 'الرقم السرى',
  phoneNumber: 'رقم الجوال',
  userName: 'اسم المستخدم',
  fullName: 'الاسم بالكامل',
  email: 'إيميل',
  otbCode: 'الرمز',
  check: 'تحقق',
  enter: 'دخول',
  createNewAccount: ' تسجيل حساب جديد',
  createAccount: ' تسجيل حساب',
  codeOtb: 'كود الرمز',
  otbTitle: 'تم إرسال رسالة إلى رقم الجوال الخاص بكم',
  otbInfo: 'تتضمن رمز OTP',
  continueOtb: 'المتابعة',
  create: 'تسجيل',
  enterLogin: 'تسجيل الدخول',
  dashboard: 'لوحة التحكم',
  marketplace: 'المتاجر',
  veterinary: 'البيطرة',
  events: 'الفاعليات',
  news: 'الأخبار',
  images: 'الصور',
  gallery: 'معرض',
  videos: 'الفيديوهات',
  video: 'فيديو',
  transactions: 'العمليات',
  payments: 'الماليات',
  website: 'الموقع',
  termsCondition: 'الشروط والأحكام',
  privacyPolicy: 'سياسة الخصوصية'
}
